import React, { useState, memo } from 'react';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import moment from 'moment';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { useSpinner } from '../../../../core/contexts/SpinnerContext';
import Header from '../../../Public/Header/Header';
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import VehicleItem from './VehicleItem';
import { getNonUsedVehicleList } from '../../../Common/Apis/ReportsApi';

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
}));

const Vehicles = () => {

  const [reportsListData, setReportsListData] = useState();
  const [searchDateFrom, setsearchDateFrom] = useState(moment().add(-1, 'd'));
  const [searchDateTo, setsearchDateTo] = useState(moment().add(-1, 'd'));
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo, setpageNo] = useState(1);

  const { setSpinner } = useSpinner();
  const muiClasses = useStyles();

  const pageSizeChanged = (i) => {
    setpageSize(i);
    setpageNo(1);
    getList(1, i);
  };

  const pageNoChanged = (i) => {
    setpageNo(i);
    getList(i, pageSize);
  };

  const getList = async (_pageNo, _pageSize) => {

    setSpinner(true);

    try {

      const queryStartDate = moment(searchDateFrom).format('YYYY-MM-DD 00:00:00');
      const queryEndDate = moment(searchDateTo).format('YYYY-MM-DD 23:59:59');

      const resData = await getNonUsedVehicleList(queryStartDate, queryEndDate, _pageNo, _pageSize);

      setReportsListData(resData);

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };



  const clickedGetReport = async (e) => {
    e.preventDefault();

    getList(pageNo, pageSize);
  };



  return (
    <ContentsWrapper header={<Header title="Unused Vehicles" />}>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <form onSubmit={clickedGetReport}>
                  <div className="row ">
                    <div className="col-lg-2">
                      <div className="form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            variant="inline"
                            ampm={false}
                            value={searchDateFrom}
                            onChange={setsearchDateFrom}
                            autoOk={true}
                            format="dd/MM/yyyy"
                            className={muiClasses.textField}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            variant="inline"
                            ampm={false}
                            value={searchDateTo}
                            onChange={setsearchDateTo}
                            autoOk={true}
                            format="dd/MM/yyyy"
                            className={muiClasses.textField}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form-group">
                        <Button
                          type="submit"
                          className=" ml-3"
                          style={{ fontWeight: '600' }}
                          variant="contained"
                          color="primary"
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {reportsListData && <VehicleItem
              items={reportsListData.Data}
              paging={reportsListData.Paging}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
            />}
          </div>
        </div>
      </div>

    </ContentsWrapper>
  );

};

export default memo(Vehicles);